import { ui } from "./uiHelpers";
import * as i18n from "i18n/util";
import * as config from "config";
import * as _ from "lodash";


export function numberToYearsString(value: number) {
    if (value === 1) {
        return ui.__("loan.durationOneYear");
    } else {
        return ui.__("loan.durationYears", { duration: value });
    }
}

export function numberToPercentageString(value: number) {
    return value.toLocaleString(config.LOCALE) + "%";
}

/**
 * Given a number 123456.893756  returns "123.456,89 EUR"
 */
export function numberToCurrencyString(value: number, withCents = true, symbol = false): string {

    if (!withCents) {
        value = Math.floor(value);
    }

    const ret = value.toLocaleString(config.LOCALE, {
        style: "currency",
        currency: config.CURRENCY,
        minimumFractionDigits: withCents ? undefined : 0,
        maximumFractionDigits: withCents ? undefined : 0,
        currencyDisplay: symbol ? "symbol" : "code" // display EUR instead of €
    });

    if (config.CURRENCY === "EUR") {
        return ret.replace("EUR", "Euro");
    } else {
        return ret;
    }
}

/**
 * Given 12345.67 returns "12345,67"
 */
export function numberToCurrencyStringShort(value: number): string {
    const valueString = value.toString();
    if (value === parseInt(valueString, 10)) {
        return valueString;
    }
    return value.toFixed(2).replace(".", config.CURRENCY_DECIMAL_SEPARATOR);
}


/**
 * Given a string "123.000,90" returns 123000.9.
 * If the string can't be parsed <defaultValue> is returned.
 */
export function currencyStringToNumber(value: string, defaultValue: number = 0): number {
    let str = value.replace(config.CURRENCY_THOUSANDS_SEPARATOR, "");
    str = str.replace(config.CURRENCY_DECIMAL_SEPARATOR, ".");
    let ret = parseFloat(str);
    if (isNaN(ret)) {
        return defaultValue;
    }

    return ret;
}

export function clamp(value: number, min: number, max: number): number {
    return Math.min(Math.max(value, min), max);
}

export function indexOfStringInKeyArray(value: string, keyArray: string[]): number | undefined {
    const foundKey = _.find(keyArray, key => { return ui.__(key as i18n.IDS) === value; });
    if (foundKey) {
        return keyArray.indexOf(foundKey);
    }
}

/**
 * Converts date to "2017-04-01"
 */
export function dateOnlyAsString(date: Date): string {

    // DO NOT USE Date.toISOString() because due to time zone issues you can jump day
    // See this: http://stackoverflow.com/questions/3066586/get-string-in-yyyymmdd-format-from-js-date-object

    // getMonth() is zero-based
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    const ret = [date.getFullYear(), (mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join("-");
    return ret;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/helpers.ts